export default function GraduateDiplomaDelivery({ initialApplication }: { initialApplication: boolean }) {
  return <section className="application-step application-step-info" aria-labelledby="graduate-diploma-info-heading">
    <div className="application-step-heading">
      <span className="application-step-number" aria-hidden="true">3</span>
      <div><span className="application-step-kicker">Review the details</span><h2 id="graduate-diploma-info-heading">Diploma delivery</h2>
        <p>Review mailing and timing information before confirming your application.</p></div>
    </div>
    <div className="application-step-body">
      <ul className="application-key-facts">
        <li>Minnesota State University, Mankato provides each graduate with one certified electronic diploma and one paper diploma per degree or certificate at no cost.</li>
        <li>Paper diplomas are mailed to the diploma address on file (U.S. addresses only). International delivery requires a shipping label through eShipGlobal. Check your address in eServices by the last day of your graduation term.</li>
        <li>Diplomas are mailed 10 – 12 weeks after the end of the term.</li>
      </ul>
      <details className="application-details" open={initialApplication}>
        <summary>Read more about diploma addresses, shipping, and timing</summary>
        <div className="application-details-content">
          <p>Paper diplomas are mailed at no cost to U.S. addresses. If your diploma is being mailed to an international address, you must purchase a shipping label through eShipGlobal.</p>
          <h3>Diploma address</h3>
          <p>Students are responsible for making sure their diploma address is accurate.</p>
          <ul>
            <li>Review or update your diploma mailing address in eServices by the last day of the term you intend to graduate.</li>
            <li>Located under Account Management &gt; Name and Address Info &gt; Address Maintenance.</li>
            <li>Recommend using an address that you will have access to 10 – 12 weeks after the end of the term.</li>
            <li>If you are moving, we highly recommend forwarding and changing your address at Official USPS Change-of-Address.</li>
          </ul>
          <p>Minnesota State Mankato is not responsible for a diploma being sent to an inaccurate address or a non-forwarded mailing address.</p>
          <h3>Diploma timeline</h3>
          <ul>
            <li>Once your degree is conferred, it is immediately posted to the transcript.</li>
            <li>The conferment process begins after the grading process concludes.</li>
            <li>Diplomas are mailed 10 – 12 weeks after the end of the term (fall, spring, summer).</li>
            <li>Diplomas are printed and mailed by a third-party vendor.</li>
          </ul>
          <p>Additional information and FAQs can be located at <a href="https://services.mnsu.edu/TDClient/30/Portal/KB/Article/1259/Understanding-the-Diploma-Timeline-and-Delivery-Process" target="_blank" rel="noreferrer">Understanding the Diploma Timeline and Delivery Process</a>.</p>
        </div>
      </details>
    </div>
  </section>;
}
